module.exports = __webpack_public_path__ + "static/media/contact-decoration@2x.bcf0b3eb.png";